// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-logo',
    props: {
        logoMode: {
            type: String,
            required: false,
            default: 'default'
        },
    },
    computed: {
        logoSimple() {
            return this.$appHost.config.logoSimple;
        },
        logoDefault() {
            return this.$appHost.config.logoDefault;
        },
        versionVariant() {
            if (utils.isEmpty(this.$appHost.config.versionState)) {
                return "fallback";
            }
            else {
                return this.$appHost.config.versionState;
            }
        },
    }
});
// #endregion
